import { FC } from "react";

import { PillBanner } from "components/footer/PillBanner";
import { PillBannerButton } from "components/footer/PillBannerButton";
import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { TooltipTrigger } from "mds/components/TooltipTrigger";
import { CircleInfoIcon, PresentPlayFilledIcon } from "mds/icons";

interface StartPresentationReminderBannerProps {
  isStartDisabled?: boolean;
  onDismiss: () => void;
  onStart: () => void | Promise<unknown>;
}

export const StartPresentationReminderBanner: FC<StartPresentationReminderBannerProps> = ({
  isStartDisabled = false,
  onDismiss,
  onStart,
}) => {
  return (
    <PillBanner
      buttonChildren={
        <>
          <PillBannerButton
            className="text-black-tint-20"
            disabled={isStartDisabled}
            eventName="Presentation reminder banner - Start"
            kind="white"
            disableWhilePending
            onClick={onStart}
          >
            {t("common.start")}
          </PillBannerButton>

          <PillBannerButton
            className="border border-black-tint-40 bg-transparent text-white hover:border-black-tint-55 hover:bg-black-tint-30 hover:text-white"
            eventName="Presentation reminder banner - Dismiss"
            onClick={onDismiss}
          >
            {t("common.dismiss")}
          </PillBannerButton>
        </>
      }
      kind="dark-gray"
      label={t("presentation.start_banner.label")}
      textChildren={
        <IconText
          iconEnd={
            <TooltipTrigger
              content={t("presentation.start_banner.tooltip")}
              label={t("presentation.start_banner.info_label")}
              place="top"
            >
              <CircleInfoIcon className="text-white" />
            </TooltipTrigger>
          }
          iconStart={<PresentPlayFilledIcon className="text-white" aria-hidden />}
          text={t("presentation.start_banner.title")}
          truncateText
        />
      }
    />
  );
};
